import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locale';
import '@/api';
// 导入antdv
import '@/components/antdv-import.js';
// 全局样式
import './assets/styles/global.less';
//兼容处理
import './utils/rem';
import eventBus from '@/common/eventBus';
Vue.prototype.$Bus = eventBus;
import loading from '@/common/loadingDirective';
Vue.directive('loading', loading);
import empty from '@/common/emptyDirective';
Vue.directive('empty', empty);
import touch from '@/common/mobileDirective';
Vue.directive('touch', touch);
import waterfall from 'vue-waterfall2';
Vue.use(waterfall);
import hxmui from "thsc-hxmui";
import "thsc-hxmui/lib/style/index.css";
Vue.use(hxmui, {
  projectName: "data_image",
  themeMode: "auto"
});
import VueTouch from 'vue-touch';
VueTouch.config.swipe = {
  direction: 'horizontal'
};
Vue.use(VueTouch, {
  name: "v-touch"
});
import vueAweSomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(vueAweSomeSwiper);
import { TaLog,WinAPI } from '@/common';
Vue.prototype.$Talog = TaLog;
Vue.prototype.$WinAPI = WinAPI
Vue.config.productionTip = false;
const app = new Vue({
  i18n,
  render: h => h(App),
  router,
  store
}).$mount('#app');